import React from "react";
import styles from "./styles.module.scss";
import Button from "../new-button";
import CrossIcon from "../../assets/svg/icons/common/CrossIcon";

function ActionBar({ text, buttonText, onButtonClick, onCrossClick, visible }) {
  return (
    <div
      className={`${styles.actionBarContainer} ${visible && styles.visible}`}
    >
      <div className={styles.actionBarPrefix}>{text}</div>
      <div className={styles.actionBarActions}>
        <Button variant="ghostWhite" onClick={onButtonClick}>
          {buttonText}
        </Button>
        <Button variant="ghostWhite" onClick={onCrossClick} condensedX>
          <CrossIcon />
        </Button>
      </div>
    </div>
  );
}

export default ActionBar;
